import { createContext, useContext } from "react";
import useAppReducer from "../reducer/app.reducer";
import * as ACTION from "./../reducer/types";
import { getAIMaturityEvaluationAPI, getUnsignedRevenue } from "../service/ai.service";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const { state, dispatch } = useAppReducer();

    const updateLeftMenu = (flag) =>
        dispatch({ type: ACTION.UPDATE_LEFT_MENU, payload: flag });

    const updateLoader = (flag) =>
        dispatch({ type: ACTION.UPDATE_LOADER, payload: flag });

    const getAIMaturityEvaluation = (params) => {
        updateLoader(true);
        getAIMaturityEvaluationAPI().then((response) => {
            if (response) {
                dispatch({
                    type: ACTION.GET_AI_MATURITY_EVALUATION,
                    payload: response,
                });
            }
        }).catch((error) => {
            console.error("Error fetching AI maturity evaluation data:", error);
        }).finally(() => updateLoader(false));
    }

    const calculateUnsignedRevenue = (data, cb) => {
        updateLoader(true);
        getUnsignedRevenue(data)
            .then((response) => {
                const payload = { ...response, revenue: data.revenue };
                dispatch({
                    type: ACTION.UPDATE_REVENUE_REPORT,
                    payload,
                });
                cb && cb(payload);
            })
            .catch(() => cb && cb())
            .finally(() => updateLoader(false));
    };

    const updateCompnayInfoSaveStatus = payload => dispatch({ type: ACTION.UPDATE_COMPANY_INFO_STATUS, payload });

    return (
        <AppContext.Provider
            value={{
                ...state,
                updateLeftMenu,
                updateLoader,
                getAIMaturityEvaluation,
                calculateUnsignedRevenue,
                updateCompnayInfoSaveStatus
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => useContext(AppContext);

export { AppProvider, AppContext };
